import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { postSPDataWithoutParams } from 'src/supportPortal/services/services'

// Persist a completed call's outcome/disposition (voice / call-outcome SupportAgentCommunicationLog).
// Backs the support call surface's Notes tab. See docs/SUPPORT_CALL_PAGE_PLAN.md §0.
export async function logSupportCallOutcome(payload = {}) {
  try {
    const response = await postSPDataWithoutParams(
      '/api/secure/cc/support/contact-actions/call/outcome',
      payload,
    )
    if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
      const data = getDataMapFromCommonResponse(response)
      return { ok: true, logId: data?.logId, status: data?.status }
    }
    return {
      ok: false,
      message:
        response?.data?.message ||
        response?.response?.data?.message ||
        'Unable to save the call outcome.',
    }
  } catch (error) {
    console.error('Error saving support call outcome:', error)
    return { ok: false, message: 'Unable to save the call outcome.' }
  }
}

// Persist one transcript segment against a call session (== PortalVoiceCallInteraction id).
// Fire-and-forget from the FE for agent-side finals; a future server STT worker uses the same path.
export async function postSupportCallTranscriptSegment(callSessionId, segment = {}) {
  if (!callSessionId) {
    return { ok: false }
  }
  try {
    const response = await postSPDataWithoutParams(
      `/api/secure/cc/support/call/${encodeURIComponent(callSessionId)}/transcript/segment`,
      segment,
    )
    return { ok: response?.status === 200 && isCommonResponseSuccessfulV2(response) }
  } catch (error) {
    return { ok: false }
  }
}
